SupportV2FlexibleContactChannelsTemplate = require '../../../../v2_flexible_contact_channels.html.mustache'
Backbone = require 'backbone'
Backbone.$ = $

class EmailFormV2FlexibleContactChannelsView extends Backbone.View
  className: 'flexible-contact-channels-view-v2'
  events:
    'DOMSubtreeModified .flexible-contact-channels-container  #live-chat-container' : 'handleDisplayOfLiveChatIcon'
    'DOMSubtreeModified .primary-chat-link#live-chat-link-container' : 'handleDisplayOfPrimaryLiveChatLink'
    'DOMSubtreeModified .secondary-chat-link#live-chat-link-container' : 'handleDisplayOfSecondaryLiveChatLink'
    'DOMSubtreeModified .tertiary-chat-link#live-chat-link-container' : 'handleDisplayOfTertiaryLiveChatLink'
    'click .flexible-email-container': 'renderEmailForm'
    'click .flexible-phone-container': 'renderPhoneView'
    'click .flex-email-link': 'renderEmailForm'
    'click .flex-phone-link': 'renderPhoneView'
    'click .flex-chat-link': 'renderChatClickView'
    'click .primary-chat-link#live-chat-link-container': 'renderChatClickView'
    'click .flexible-contact-channels-container  #live-chat-container': 'renderChatClickView'

  initialize: (options) ->
    @options = options || {}
    _.bindAll.apply(_, [this].concat(_.functions(this)))
    @I18nScope = 'modules.support'
    @template = SupportV2FlexibleContactChannelsTemplate
    @model = Groupon.Support.FlexibleContactChannelModel
    @mainView = @options.mainView

  render: () ->
    @model.presentContactChannels()
    @$el.empty()
    options =
      renderLayout:true
      withoutChat: not @isLiveChatEnabled()
    @$el.append(@arrangeLayoutView(@toHash(options)))
    this

  isLiveChatEnabled: () ->
    Groupon.Support.LiveChatModel.isLiveChatEnabled()

  renderEmailForm: (e)->
    @mainView.renderEmailForm()

  renderPhoneView: ()->
    @mainView.renderPhoneNumberView()

  renderChatClickView: () ->
    @mainView.renderChatClickView()

  handleDisplayOfLiveChatIcon: ()->
    @$el.find('.flex-contact-channels-without-chat').empty()
    @setFlexibleLiveChatDisplayCallBack(@handleDisplayOfLiveChatIcon)
    if @isLiveChatIconVisible()
      window.showDOMElems $('.help-wizard-content > .flexible-contact-channels-container')
      window.hideDOMElems $('.flex-contact-channels-without-chat')
    else
      window.hideDOMElems $('.help-wizard-content > .flexible-contact-channels-container')
      window.showDOMElems $('.flex-contact-channels-without-chat')
      $('.flex-contact-channels-without-chat').html(@arrangeLayoutView(@toHash({withoutChat: true})))

  handleDisplayOfPrimaryLiveChatLink: ()->
    primaryChatTextElem = $(".flex-chat-channel-text")
    @toggleDomElemsBasedOnLiveChat primaryChatTextElem

  handleDisplayOfSecondaryLiveChatLink: ()->
    secondaryFlexibleLiveChatContainerElem = $('.secondary-flex-chat-channel')
    flexTertiaryOrTextElem = $('.flex-channel-or-text')
    DOMelemsToToggle = [secondaryFlexibleLiveChatContainerElem, flexTertiaryOrTextElem]
    if @model.get('formattedContactChannels').contact_channels.length is 2 then DOMelemsToToggle.push $('.flex-secondary-channel-also-text')
    @toggleDomElemsBasedOnLiveChat DOMelemsToToggle

  handleDisplayOfTertiaryLiveChatLink: ()->
    tertiaryFlexibleLiveChatContainerElem = $('.tertiary-flex-chat-channel')
    flexTertiaryOrTextElem = $('.flex-channel-or-text')
    @toggleDomElemsBasedOnLiveChat [tertiaryFlexibleLiveChatContainerElem, flexTertiaryOrTextElem]

  toggleDomElemsBasedOnLiveChat:(domElems)->
    if window.liveChatLinkVisible()
      window.showDOMElemsInline domElems
    else
      window.removeDOMElemsInline domElems
      window.hideDOMElems domElems

  setFlexibleLiveChatDisplayCallBack: (liveChatDisplayCallback)->
    window.setLiveChatDisplayCallBack $('a img', @liveChatIconContainer()), liveChatDisplayCallback

  isLiveChatIconVisible: ->
    window.liveChatVisible $('a img', @liveChatIconContainer())

  handleDisplayOfContactChannels: () ->
    if @liveChatIconContainer().length > 0
      @handleDisplayOfLiveChatIcon()

  liveChatIconContainer: () ->
    $('.flexible-contact-channels-container #live-chat-container')

  toHash: ({withoutChat, renderLayout})->
    contactChannelhash = {}
    if withoutChat
      contactChannelhash = @model.get('contactChannelsWithoutBoldChat')
    else if @model.has('formattedContactChannels')
      contactChannelhash = @model.get('formattedContactChannels')
    else
      contactChannelhash = @model.get('contactChannelsWithoutBoldChat')

    additionalInfo =
      orderMsg: @setOrderInfo()
      issueMsg: @setIssueInfo()
    if renderLayout
      additionalInfo.renderLayout = true
    hash = $.extend true, additionalInfo, contactChannelhash
    hash

  setOrderInfo: ->
    order = Groupon.Support.currentOrder
    if order
      title = order.deal?.title || order.merchant?.name
      if title
        I18n.translate('js.modules.support.issue_about_this_order', {dealTitle: title})

  setIssueInfo: ->
    issue = Groupon.Support.ContentModel.getSearchInputIssue() || Groupon.Support.ContentModel.getSubCategory()?.text
    if issue
      I18n.translate('js.modules.support.saw_you_have_issue', {issue: issue})

  arrangeLayoutView: (hash) ->
    html = toHtml(@template, hash, @I18nScope)
    $html = $(html)
    $container = @arrangeLayoutOfIcons(hash, $html)
    $container

  addBloodHoundTagToIcon: (channel, $container, type) ->
    contactElem = @getContactChannelIcon(channel, $container)
    addBloodHoundTagToDOMElems(contactElem, "#{type}-#{channel}-icon")
    contactElem

  addAttributesToPrimaryIcon: (primaryContactChannel, $container) ->
    primaryContactElem = @addBloodHoundTagToIcon(primaryContactChannel.channel, $container, "primary")
    addPreferredContactClass primaryContactElem
    addBtnPrimaryClass primaryContactElem
    primaryContactElem

  renderIcons: (orderedContactChannelElements, $container) ->
    $('.flexible-contact-channel-icon-container', $container).empty()
    for contactChannelElement in orderedContactChannelElements
      $('.flexible-contact-channel-icon-container', $container).append(contactChannelElement)

  arrangeLayoutOfIcons: (hash, $container)->
    orderedContactChannelElements = []
    if hash.contact_channels?
      for contact_channel in hash.contact_channels
        if contact_channel.primary?.channel
          primaryContactElem = @addAttributesToPrimaryIcon(contact_channel.primary, $container)
          orderedContactChannelElements.push(primaryContactElem)

      @renderIcons(orderedContactChannelElements, $container)
    $container

  getContactChannelIcon: (type, $container) ->
    switch type
      when "chat"
        contactElem = @liveChatIconElem($container)
      when "email"
        contactElem = @emailIconElem($container)
      when "phone"
        contactElem = @phoneIconElem($container)
    contactElem

  emailIconElem: ($container)->
    $('.flexible-contact-channel-icon-container .flexible-email-container', $container)

  phoneIconElem: ($container)->
    $('.flexible-contact-channel-icon-container .flexible-phone-container', $container)

  liveChatIconElem: ($container)->
    $('.flexible-contact-channel-icon-container .flexible-chat-container', $container)

  renderLiveChat: ()->
    if @model.get('liveChatExists')
      if @model.get("primaryChannelIsBoldChat")
        @mainView.renderLiveChat({
          liveChatMode: 'static',
          liveChatType: Groupon.Support.LiveChatModel.getFlexibleV2LiveChatType()
        })
      @mainView.renderLiveChat({
        liveChatMode: 'static',
        liveChatType:  Groupon.Support.LiveChatModel.getLinkLiveChatType(),
        startFromSameViewState: @model.get("primaryChannelIsBoldChat")
      })

module.exports = EmailFormV2FlexibleContactChannelsView
